<template>
  <v-layout
    v-if="!$apollo.loading && transaction"
    wrap
  >
    <v-flex>
      <v-card
        class="wallet-card"
      >
        <v-flex
          pb-5
        >
          <center>
            <div>
              <h4>{{ $t('gateway.walletPleaseSend1') }}</h4>
              <h3>{{ transaction.amount }} {{ currency }}</h3>

              <b>{{ $t('gateway.copyWallet') }}</b>
              <v-text-field
                v-model="transaction.address"
                name="gateway-wallet"
                class="centered-input"
                readonly
                @focus="$event.target.select()"
              >
                <template v-slot:append>
                  <v-icon
                    v-clipboard:copy="transaction.address"
                    style="cursor:pointer;"
                  >
                    mdi-content-copy
                  </v-icon>
                </template>
              </v-text-field>
              <p>{{ $t('gateway.scanQrCode') }}</p>
              <qrcode
                :value="transaction.address"
                :options="{ width: 200 }"
              />
            </div>
            {{ $t('gateway.afterPayment') }}<br>
            <b><a
              :href="transaction.status_url"
              target="_blank"
            >{{ $t('gateway.afterPaymentStatus') }}</a></b>
            <p class="warning mt-5 pt-3 pb-3">
              <small>{{ $t('gateway.afterPaymentWarning') }} </small>
            </p>
          </center>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout v-else>
    <v-flex
      text-center
      mb-10
    >
      <v-progress-circular
        :size="40"
        color="primary"
        class="mb-2"
        indeterminate
      /><br>
      <b>{{ $t('packs.almostDone') }}</b>
    </v-flex>
  </v-layout>
</template>

<script>

import VueQrcode from "@chenfengyuan/vue-qrcode";
import COINPAYMENTS_CREATE_TRANSACTION_MUTATION from "@/graphql/mutations/CoinPaymentsCreateTransaction.gql";
import transactions from '@/views/Affiliates/partial/Transactions.vue';


export default {
  name: "AiviaGateway",
  components: {
    qrcode: VueQrcode,
  },
  props: {
    invoice: {
      type: Object,
      default() {
        return null;
      }
    },
    currency: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      transaction: null,
      loading: false
    };
  },
  computed: {
    
  },
  created() {
    this.CreateTransaction()
  },
  methods: {
   CreateTransaction() {
     this.$apollo
      .mutate({
        mutation: COINPAYMENTS_CREATE_TRANSACTION_MUTATION,
        variables: {
          invoice_id: this.invoice.id,
          currency: this.currency
        }
      })
      .then(data => {
        this.transaction = data.data.coinPaymentsCreateTransaction
      })
      .catch(error => {
        this.errorHandler(error);
        this.loading = false;
      });
   }
  },
  

};
</script>
<style lang="scss" >
.wallet-card {
  padding: 10px 20px !important;
  h3 {
    margin: 5px;
  }
  h4 {
    margin: 15px 0 0;
    font-weight: 600 !important;
  }
  center {
    margin-top: 10px;
  }
  .v-card__title {
    margin-bottom: 30px !important;
  }
  p {
    margin: 0;
  }
  .centered-input {
    input {
      text-align: center !important;
    }
  }
  .v-image {
    margin: 15px 0 10px;
  }
  .check-mark {
    color: #75b211;
    font-size: 54px;
  }
}
</style>
